import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { PageHeader } from "@excoleadershipui/pionweblib";
import { Link, useLocation } from "react-router-dom";
//routes
import { ASSESSMENT_BASE_URL } from "../../utils/config";

// material ui
import { IconButton } from "@mui/material";
// icons
import SummarizeIcon from "@mui/icons-material/Summarize";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
// components
import Layout from "../../layout/Layout";
import {
  MuiDataGrid,
  GridCellExpand,
  FormTextField as MyTextInput,
  Notifier,
  ErrorNotifier,
  MuiTooltip,
} from "../../components";
import { HeaderDropDown } from "../../components/common/HeaderDropdown";
// redux
import {
  getAssessmentTemplate,
  getReportListById,

} from "../../features/prepare_assessments/prepareAssessmentSlice";
import { getCustomer } from "../../features/customer/customerSlice";
import { getassessmentType, setAssessmentType } from "../../features/config/assessmentTypeSlice";



// -------------------------------------------------------------------------

const style = {
  position: "absolute",
  top: "50%",
  left: "60%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "5px",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};

// ------------------------------------------------------------------------

const AnalyzeAndReport = (props) => {
  // const [assessmentType, setAssessmentType] = useState(null)
  const [selectedCustValue, setSelectedCustValue] = useState(null)
  const [selectedAccountValue, setSelectedAccountValue] = useState(null)
  const dispatch = useDispatch();

  const location = useLocation();
  console.log("locationo", location)
  const { message, errMessage, assessmentTemplateData } = useSelector(
    (state) => ({ ...state.prepareAssessment })
  );

  const { selectedAccountDataList, selectedCustomerDataList } = useSelector((state) => ({ ...state?.account }));
  const { assessmentTypeData, assessmentType } = useSelector((state) => ({
    ...state.assessmentTypeConfig,
  }));


  function renderCellExpand(params) {
    return (
      <GridCellExpand
        value={params.value || ""}
        width={params.colDef.computedWidth}
      />
    );
  }

  const data = {
    rows:
      assessmentType?.assessmentType ?
        assessmentTemplateData?.length > 0 &&
        assessmentTemplateData?.filter((value) => value.status === "Completed"
          && value.assessmentType?.assessmentType === assessmentType?.assessmentType) : assessmentTemplateData.filter((value) => value.status === "Completed"),
    columns: [
      {
        field: "assessmentTemplateName",
        headerName: "Assessment Template Name",
        width: 250,
        renderCell: renderCellExpand,
      },

      {
        field: "assessmentTemplateDisplayName",
        headerName: "Template Display Name",
        width: 250,
        renderCell: renderCellExpand,
      },

      {
        field: "config",
        headerName: "View Reports",
        type: "actions",
        width: 130,
        renderCell: (params) => {
          return (
            params?.row?.assessmentTracking &&
            (params?.row?.assessmentTracking?.assessmentStatus ===
              "Published" ||
              params?.row?.assessmentTracking?.assessmentStatus ===
              "Completed") && (
              <MuiTooltip title="View Report" placement="bottom">
                <Link
                 aria-label="view-reports"
                  to="/exco/assessment/report"
                  state={{
                    trackingSelectedData: params?.row,
                    permissions: location?.state?.permissions,
                    assessmentType: assessmentType,
                    selectedCustValue: selectedCustValue,
                    selectedAccountValue: selectedAccountValue
                  }}
                >
                  <SummarizeIcon style={{ color: "#808080" }} />
                </Link>
              </MuiTooltip>
            )
          );
        },
      },

      {
        field: "previewReport",
        headerName: "Response Status",
        type: "actions",
        width: 150,
        renderCell: (params) => {
          return (
             params?.row?.assessmentTracking &&
            (params?.row?.assessmentTracking?.assessmentStatus ===
              "Published" ||
              params?.row?.assessmentTracking?.assessmentStatus ===
              "Completed") && (
            <div>


              <MuiTooltip title="Response Status" placement="bottom">
                {/* <Link to="/exco/report/preview" state={{clientSelectedData: params?.row}}> */}
                <a
                 aria-label="response-status"
                  href={`${ASSESSMENT_BASE_URL}/v1/api/excel-parser/execl-download-response-status?templateId=${params?.row?.id}`}
                  // target="_blank"
                >
                  <IconButton aria-label="download">
                    <FileDownloadIcon style={{ color: "#808080" }} />
                  </IconButton>
                </a>
                {/* </Link> */}
              </MuiTooltip>


            </div>)
          );
        },
      },

      {
        field: "detailedDescription",
        headerName: "Description",
        width: 350,
        renderCell: renderCellExpand,
      },

    ],
  };

  useEffect(() => {
    // dispatch(getAssessmentTemplate());
    dispatch(getCustomer())
    dispatch(getassessmentType())

  }, []);



  // useEffect(() => {
  //   dispatch(setAssessmentType(assessmentTypeData?.find((data) => data.code === "ELI")));
  // }, [assessmentTypeData])

  useEffect(() => {
    // if assessment type is selected no need to call this use effect then the state variable it wont change so that time 
    // you will get the state variable stored and it will not be resetted everytime
    if (!assessmentType && assessmentTypeData?.length > 0) {
      const defaultType = assessmentTypeData.find(
        (data) => data.code === "ELI"
      );

      if (defaultType) {
        dispatch(setAssessmentType(defaultType));

      }
    }
  }, [assessmentTypeData]);
  const getCustomerSelectedValue = (data) => {
    // formik.setFieldValue("custName", data)
    setSelectedCustValue(data)
  }

  const getAccountSelectedValue = (data) => {
    // formik.setFieldValue("account", data)
    setSelectedAccountValue(data)
  }

  return (
    <>
      <>
        {/* <PageHeader variant="pageHeader">Assessment Response Report</PageHeader> */}
        <HeaderDropDown
          sx={{ marginTop: "1rem" }}
          heading="Assessment Response Report"
          assessmentTypeData={assessmentTypeData}
          assessmentType={assessmentType}
          setAssessmentType={(value) => dispatch(setAssessmentType(value))}
        />
        <MuiDataGrid
          getCallBackCustomer={(data) => getReportListById({ assessmentCustomerId: data })}
          getCallBackOne={getAssessmentTemplate}
          getCallBackTwo={(data) => getReportListById({ assessmentCustomerAccountId: data })}
          // getCallBackargs = {defaultCallBack}
          getAccountSelectedValue={(data) => getAccountSelectedValue(data)}
          getCustomerSelectedValue={(data) => getCustomerSelectedValue(data)}
          // assessmentType={assessmentType}
          isAccount={true}
          isCustomer={true}

          toolbarColumn={true}
          // toolbarFilter={true}
          toolbarDensity={true}
          toolbarExport={true}
          data={data}
        />
      </>

      {errMessage && <ErrorNotifier message={errMessage} />}
      {message && <Notifier message={message} />}
    </>
  );
};

export default AnalyzeAndReport;
